var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { SdsInputMultilingualBase } from '../_sds-input-multilingual-base';
import { sdsCustomElement } from '../../utilities/custom-components';
/**
 * `sds-input-multilingual` is a web component designed for multilingual input,
 * allowing users to enter and manage text in multiple languages.
 * It provides features such as error messages, and placeholders,
 * making it suitable for forms and applications that require language-specific inputs.
 *
 * ### Attributes
 * - `invalid`: Indicates if the input is invalid. Defaults to `false`.
 * - `error-message`: The error message displayed when there is a validation error.
 * - `max-length`: The maximum number of characters allowed in the input. Defaults to `1000`.
 * - `placeholder`: The placeholder text shown when the input is empty.
 * - `focused`: Indicates if the input is focused. Defaults to `false`.
 * - `disabled`: Indicates if the input is disabled. Defaults to `false`.
 * - `hint`: A hint to assist users with additional information or guidance.
 * - `current-language`: The currently selected language for input.
 * - `rtl`: A list of languages to be displayed in right-to-left (RTL) mode.
 *
 * @tag sds-input-multilingual
 */
let SdsInputMultilingual = (() => {
    var _SdsInputMultilingual_errorMessage_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-input-multilingual')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = SdsInputMultilingualBase;
    let _errorMessage_decorators;
    let _errorMessage_initializers = [];
    let _errorMessage_extraInitializers = [];
    var SdsInputMultilingual = _classThis = class extends _classSuper {
        /**
         * The error message displayed when there is a validation error.
         * This attribute provides a way to communicate specific issues to the user.
         *
         * Defaults to an empty string.
         *
         * @attr {string} error-message - The error message text.
         */
        get errorMessage() { return __classPrivateFieldGet(this, _SdsInputMultilingual_errorMessage_accessor_storage, "f"); }
        set errorMessage(value) { __classPrivateFieldSet(this, _SdsInputMultilingual_errorMessage_accessor_storage, value, "f"); }
        render() {
            return html `
            <sds-input
                id="input"
                placeholder="${this.placeholder}"
                value="${this.getCurrentLanguageValue()}"
                hint="${this.hint}"
                .hasClear="${!this.isMultiLanguageValue()}"
                .errorMessage="${this.errorMessage}"
                ?invalid="${this.invalid}"
                ?disabled="${this.disabled}"
                @focus="${() => this.handleFocus()}"
            ></sds-input>
        `;
        }
        addEventListener(type, listener, options) {
            super.addEventListener(type, listener, options);
        }
        createInputElement() {
            return document.createElement('sds-input');
        }
        getContentClass() {
            return 'sds-multilingual-content--input';
        }
        constructor() {
            super(...arguments);
            _SdsInputMultilingual_errorMessage_accessor_storage.set(this, __runInitializers(this, _errorMessage_initializers, ''));
            __runInitializers(this, _errorMessage_extraInitializers);
        }
    };
    _SdsInputMultilingual_errorMessage_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsInputMultilingual");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _errorMessage_decorators = [property({ type: String, attribute: 'error-message' })];
        __esDecorate(_classThis, null, _errorMessage_decorators, { kind: "accessor", name: "errorMessage", static: false, private: false, access: { has: obj => "errorMessage" in obj, get: obj => obj.errorMessage, set: (obj, value) => { obj.errorMessage = value; } }, metadata: _metadata }, _errorMessage_initializers, _errorMessage_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsInputMultilingual = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsInputMultilingual = _classThis;
})();
export { SdsInputMultilingual };
